<template>
	<div>
		<div class="flexcenter"
			style="margin-top:20px;background:white;padding:5px;border-radius: 5px;border:1px solid lightgray;">
			<input type="text" v-model="this.postalCode" maxlength="5"
				style="width:calc(100% - 20px);padding:5px;border:0px solid transparent;outline:none;"
				placeholder="Ange ditt postnummer" />
			<Circle fileName="w3_close_white" size="20px" padding="25%" color="--grey-5" @click="this.postalCode = ''" />

		</div>

		<div v-if="this.postalCode" ref="postalCodeList"
			style="max-height:200px;overflow:scroll;margin-top:10px;border-bottom:1px solid var(--grey-5);">

			<div style="padding-top:10px;padding-bottom:10px;">
				<ResellerRow v-for="reseller in this.resellerList?.slice(0, 30)" :key="reseller.resellerId"
					:reseller="reseller" />

				<div class="flexcenter link" style="margin-top:10px;padding-top:10px;padding-bottom:10px;justify-content: end;"
					@click="this.$router.push({ name: 'Reseller' })">
					<b>Visa alla återförsäljarna</b>
					<Icon fileName="w3_chevron_right_dark" style="width:8px;height:12px;margin-left:5px;" />
				</div>


			</div>
		</div>



	</div>
</template>
<script>
import { STORE_GETTER } from '../../store/store';


//import { PRODUCT_STORE_ACTION } from '@/store/product-store';
//import EntityHeaderSort from "@/components/entity/EntityHeaderSort.vue";
//import listHelper from "@/helper/list-helper.js";
import { resellerListMixin } from "@/mixins/resellerListMixin.js";
import ResellerRow from './ResellerRow.vue';

export default {
	name: "ProductResellerView",
	components: { ResellerRow  },
	mixins: [resellerListMixin ],
	props: {
		productTypeKey: Number
	},
	data() {
		return {

		};
	},
	computed: {

		baseModel() {
			return this.$store.getters[STORE_GETTER.BASE_MODEL]
		},


	},
	watch: {
		productTypeKey: function (pt) {

			this.setupFilter(pt);

			
		},
		postalCode: function () {
			const postalCodeList = this.$refs["postalCodeList"];


			if (postalCodeList) {
				postalCodeList.scrollTop = 0;
			}
		},

		//"product.name": {
		//	handler() {
		//		this.product.meta.state = settings.STATE_UPDATED
		//	}, deep: true
		//},
	},
	methods: {
	
		setupFilter(pt){

			this.postalCodeFilter = null,
				this.postalCodeFilterMc = false
			this.postalCodeFilterCykel = false,
				this.postalCodeFilterBil = false,
				this.postalCode = null

			if (pt == 1) {
				this.postalCodeFilterMc = true
			} else if (pt == 2) {
				this.postalCodeFilterCykel = true
			} else if (pt == 3) {
				this.postalCodeFilterBil = true
			}

			
		}


	},
	created() {
		this.setupFilter(this.productTypeKey)
	}
};
</script>

<style scoped></style>